import { ExamSessionDetails } from '../../../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import { toast } from 'react-toastify';
import appApi from '../../../../../../../../../../api/app-api';

export const removeProtectorFromSchedulingOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number,
  sessionId: number | undefined,
  scheduleId: number | undefined,
  setSessionDetails: (sessions: ExamSessionDetails[]) => any,
) => {
  try {
    if (!programId || !courseId || !sessionId || !scheduleId) {
      toast.warn('לא ניתן לאתר את מזהה התוכנית ו/או הקורס');
      return;
    }
    //appApi.deleteExamClasses();
  } catch (e) {
    console.error(
      `removeProtectorFromSchedulingOperation is failed with the programId: ${programId}, courseId: ${courseId}, examId: ${examId}, sessionId: ${sessionId}, scheduleId: ${scheduleId} with the error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  }
};
